import { useEffect, useState } from "react";
import { api, fmt } from "@/lib/api";

/** Live quote summary on the manual job form: same engine as the quote builder, nothing is saved. */
export function JobQuoteSummary({ form, line, currency }) {
  const [r, setR] = useState(null);
  const key = JSON.stringify([form?.customer_id, line, form?.quantity]);
  useEffect(() => {
    setR(null);
    if (!form?.customer_id || !line.job_type || !Number(form.quantity)) return undefined;
    const t = setTimeout(() => api.post("/quotes/calculate", { customer_id: form.customer_id, title: form.title || "Manual job", lines: [{ ...line, quantity: Number(form.quantity) }] })
      .then((x) => setR(x.data)).catch((e) => setR({ error: e.response?.data?.detail || "Can't price this job yet" })), 400);
    return () => clearTimeout(t);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  const c = r?.computed?.[0];
  return (
    <div className="sticky top-0 z-10 min-w-0 rounded-md border border-slate-200 bg-white/95 p-3 text-xs shadow-sm backdrop-blur" data-testid="job-quote-summary">
      <div className="flex items-center justify-between"><span className="font-semibold text-[#13294B]">Quote summary</span>
        <span className="text-sm font-bold text-[#13294B]" data-testid="job-quote-total">{r?.totals ? fmt(r.totals.total, currency) : "\u2014"}</span></div>
      {!r && <p className="mt-1 text-slate-500" data-testid="job-quote-hint">Pick customer, job type, material and quantity to see the running quote.</p>}
      {r?.error && <p className="mt-1 text-amber-700" data-testid="job-quote-error">{String(r.error)}</p>}
      {c && (
        <>
        <ul className="mt-2 max-h-32 space-y-0.5 overflow-y-auto" data-testid="job-quote-lines">
          {c.components.filter((x) => x.amount).map((x, i) => <li key={i} className="flex justify-between gap-2"><span className="min-w-0 truncate" title={x.description}>{x.description}</span><span className="shrink-0 tabular-nums">{fmt(x.amount, currency)}</span></li>)}
        </ul>
        <div className="mt-1 flex justify-between border-t pt-1 font-medium" data-testid="job-quote-cost-price"><span>Cost {fmt(r.totals.cost, currency)}</span><span>Price {fmt(c.price, currency)}</span></div>
        </>
      )}
    </div>
  );
}
